var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/index.ts
import { isConfigSettled, subscribeToConfig } from "@leagueplatform/config";
import { Auth } from "@leagueplatform/auth";

// src/segment/segment.ts
import { AnalyticsBrowser } from "@segment/analytics-next";
import { getConfig } from "@leagueplatform/config";
var segment = new AnalyticsBrowser();
var segmentIdentify = (user) => segment.identify(user.id, user);
var sendSegmentEvent = (eventName, props) => {
  segment.track(eventName, __spreadProps(__spreadValues({}, props), {
    tenant_id: getConfig().config.core.tenantId || ""
  }));
};

// src/analytics.ts
import { getConfig as getConfig3 } from "@leagueplatform/config";
import { getIsImpersonator } from "@leagueplatform/auth-utils";

// src/league-analytics/league-analytics.ts
import { SocketAsFetch } from "@leagueplatform/socket-as-fetch";
import { captureError } from "@leagueplatform/observability";
import { isLoginRequiredError } from "@leagueplatform/auth";

// src/utils/utils.ts
var cached = {
  getEnvironmentName: null,
  isIOS: null,
  isAndroidOS: null,
  isNativeWebView: null,
  isIOSWebView: null,
  isAndroidWebView: null,
  isMobileOS: null,
  isMobileBrowser: null,
  isDesktop: null
};
var reset = () => {
  cached.getEnvironmentName = null;
  cached.isMobileOS = null;
  cached.isIOS = null;
  cached.isDesktop = null;
  cached.isIOS = null;
  cached.isAndroidOS = null;
  cached.isAndroidWebView = null;
  cached.isIOSWebView = null;
};
var isMobileOS = (userAgent) => {
  cached.isMobileOS = cached.isMobileOS !== null ? cached.isMobileOS : /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    userAgent
  );
  return cached.isMobileOS;
};
var isDesktop = (userAgent) => {
  cached.isDesktop = cached.isDesktop !== null ? cached.isDesktop : !isMobileOS(userAgent);
  return cached.isDesktop;
};
var isIOS = (userAgent) => {
  cached.isIOS = cached.isIOS !== null ? cached.isIOS : /iphone|ipod|ipad/.test(userAgent.toLowerCase());
  return cached.isIOS;
};
var isAndroidOS = (userAgent) => {
  cached.isAndroidOS = cached.isAndroidOS !== null ? cached.isAndroidOS : userAgent.toLowerCase().indexOf("android") > -1;
  return cached.isAndroidOS;
};
var isIOSWebView = (userAgent, isStandalone) => {
  cached.isIOSWebView = cached.isIOSWebView !== null ? cached.isIOSWebView : isIOS(userAgent) && !isStandalone && /AppleWebKit/i.test(userAgent);
  return cached.isIOSWebView;
};
var isAndroidWebView = (cookiesSayAndroid) => {
  cached.isAndroidWebView = cached.isAndroidWebView !== null ? cached.isAndroidWebView : cookiesSayAndroid;
  return cached.isAndroidWebView;
};
var getEnvironmentName = () => {
  const { userAgent } = window.navigator;
  const cookiesSayAndroid = document.cookie.indexOf("Device=Android") > -1;
  const isStandalone = window.navigator.standalone;
  if (!cached.getEnvironmentName) {
    const prefix = isDesktop(userAgent) ? "desktop" : "mobile";
    let platform;
    let suffix;
    if (isAndroidOS(userAgent)) {
      platform = "android";
      suffix = isAndroidWebView(cookiesSayAndroid) ? "native" : "browser";
    } else if (isIOS(userAgent)) {
      platform = "ios";
      suffix = isIOSWebView(userAgent, isStandalone) ? "native" : "browser";
    } else {
      platform = "web";
      suffix = "browser";
    }
    cached.getEnvironmentName = `${prefix}-${platform}-${suffix}`;
  }
  return cached.getEnvironmentName;
};

// src/league-analytics/league-analytics.ts
var sendAnalyticsToLeague = (params, name) => __async(void 0, null, function* () {
  const payload = {
    name,
    params: __spreadProps(__spreadValues({}, params), {
      platform: "web",
      environment: getEnvironmentName(),
      userAgent: window.navigator.userAgent
    }),
    echo: true
  };
  SocketAsFetch.fetch(
    {
      message_type: "set_analytics_event",
      info: payload
    },
    {
      onInternalError: (error) => {
        if (isLoginRequiredError(error)) {
          throw error;
        }
      }
    }
  ).catch((error) => {
    if (!isLoginRequiredError(error))
      captureError(
        new Error(
          `Could not send analytics to League due to an internal WS fetch error. ${error}`
        )
      );
  });
});

// src/constants.ts
var GA_EVENT = "ga_event";
var EVENT_NAME = /* @__PURE__ */ ((EVENT_NAME2) => {
  EVENT_NAME2["BUTTON_CLICKED"] = "button clicked";
  EVENT_NAME2["EVENT_FIRED"] = "event fired";
  EVENT_NAME2["NAVIGATION_TAB_CLICKED"] = "navigation tab clicked";
  EVENT_NAME2["NAVIGATION_BAR_CLICKED"] = "navigation bar clicked";
  EVENT_NAME2["RESOURCE_CLICKED"] = "resource clicked";
  EVENT_NAME2["SCREEN_LOADED"] = "screen loaded";
  EVENT_NAME2["QUERY_RETURNED"] = "query returned";
  return EVENT_NAME2;
})(EVENT_NAME || {});
var PRODUCT_AREA = /* @__PURE__ */ ((PRODUCT_AREA2) => {
  PRODUCT_AREA2["APPS_AND_DEVICES"] = "apps and devices";
  PRODUCT_AREA2["HEALTH_ASSESSMENTS"] = "health assessments";
  PRODUCT_AREA2["JOURNEY"] = "health journey";
  PRODUCT_AREA2["ONBOARDING"] = "onboarding";
  PRODUCT_AREA2["REWARDS"] = "rewards";
  PRODUCT_AREA2["WALLET"] = "wallet";
  PRODUCT_AREA2["ENROLLMENT"] = "enrollment";
  PRODUCT_AREA2["HR_ADMIN"] = "hr admin";
  PRODUCT_AREA2["GET_CARE"] = "get care";
  PRODUCT_AREA2["CARE"] = "care";
  PRODUCT_AREA2["HOME_SCREEN"] = "home screen";
  PRODUCT_AREA2["SETTINGS"] = "settings";
  PRODUCT_AREA2["CLAIMS"] = "claims";
  PRODUCT_AREA2["LOGIN"] = "login";
  return PRODUCT_AREA2;
})(PRODUCT_AREA || {});
var SUB_PRODUCT_AREA = /* @__PURE__ */ ((SUB_PRODUCT_AREA2) => {
  SUB_PRODUCT_AREA2["CHALLENGES"] = "challenges";
  SUB_PRODUCT_AREA2["POINTS"] = "points";
  SUB_PRODUCT_AREA2["CHAT"] = "chat";
  SUB_PRODUCT_AREA2["DOCUMENTS"] = "documents";
  SUB_PRODUCT_AREA2["MESSAGING"] = "messaging";
  SUB_PRODUCT_AREA2["ACCOUNT_SET_UP"] = "account set up";
  SUB_PRODUCT_AREA2["ACHIEVEMENTS"] = "achievements";
  SUB_PRODUCT_AREA2["HOMESCREEN"] = "homescreen";
  SUB_PRODUCT_AREA2["CALLBACK"] = "callback";
  SUB_PRODUCT_AREA2["LIVE_CHAT"] = "live chat";
  SUB_PRODUCT_AREA2["CLAIM_DETAILS"] = "claim details";
  SUB_PRODUCT_AREA2["CLAIMS"] = "claims";
  SUB_PRODUCT_AREA2["SUMMARY"] = "summary";
  SUB_PRODUCT_AREA2["RECENT_CLAIMS_WIDGET"] = "recent claims widget";
  SUB_PRODUCT_AREA2["ACTIVITY_STACK_WIDGET"] = "activity stack widget";
  SUB_PRODUCT_AREA2["MAINTENANCE"] = "maintenance";
  SUB_PRODUCT_AREA2["PERSONAL_INFO"] = "personal info";
  SUB_PRODUCT_AREA2["COMMUNICATION_PREFERENCES"] = "communication preferences";
  SUB_PRODUCT_AREA2["CARE_COLLECTIONS_MENU"] = "care collections menu";
  SUB_PRODUCT_AREA2["DOCUMENT_PREFERENCES"] = "document preferences";
  return SUB_PRODUCT_AREA2;
})(SUB_PRODUCT_AREA || {});
var SCREEN_NAMES = /* @__PURE__ */ ((SCREEN_NAMES2) => {
  SCREEN_NAMES2["HOME_PAGE"] = "home page";
  SCREEN_NAMES2["HOMEPAGE"] = "homepage";
  SCREEN_NAMES2["HOME_SCREEN"] = "home screen";
  SCREEN_NAMES2["HOME"] = "home";
  SCREEN_NAMES2["BENEFIT_PAGE"] = "benefit page";
  SCREEN_NAMES2["FEATURE_HIGHLIGHT"] = "feature highlight";
  SCREEN_NAMES2["CARE_COLLECTION"] = "care collection";
  SCREEN_NAMES2["CARE_COLLECTIONS"] = "care collections";
  SCREEN_NAMES2["CARE_COLLECTIONS_MENU"] = "care collections menu";
  SCREEN_NAMES2["HEALTH_ADVICE_AND_SUPPORT"] = "health advice and support";
  SCREEN_NAMES2["CARE_DOCUMENTS"] = "care documents";
  SCREEN_NAMES2["HEALTH_CAMPAIGN_DETAIL"] = "health campaign detail";
  SCREEN_NAMES2["HEALTH_PROFILE"] = "health profile";
  SCREEN_NAMES2["MY_DOCUMENTS"] = "my documents";
  SCREEN_NAMES2["ALL_DOCUMENTS"] = "all documents";
  SCREEN_NAMES2["DELETE_DOCUMENT"] = "delete document";
  SCREEN_NAMES2["RENAME_DOCUMENT"] = "rename document";
  SCREEN_NAMES2["ADD_A_DOCUMENT"] = "add a document";
  SCREEN_NAMES2["QUICK_ACTION_DETAIL"] = "quick action detail";
  SCREEN_NAMES2["SETTINGS"] = "settings";
  SCREEN_NAMES2["SUPPORT"] = "support";
  SCREEN_NAMES2["DELETE_ACCOUNT"] = "delete account";
  SCREEN_NAMES2["COMMUNICATION_PREFERENCES"] = "communication preferences";
  SCREEN_NAMES2["PERSONAL_INFO"] = "personal info";
  SCREEN_NAMES2["ACCOUNT_SET_UP"] = "account set up";
  SCREEN_NAMES2["CALLBACK_REQUEST_FORM"] = "callback request form";
  SCREEN_NAMES2["CALLBACK_REQUEST_CONFIRMATION"] = "callback request confirmation";
  SCREEN_NAMES2["HEALTH_REPORT_PAGE"] = "health report page";
  SCREEN_NAMES2["CLAIM_DETAILS"] = "claim details";
  SCREEN_NAMES2["SUMMARY"] = "summary";
  SCREEN_NAMES2["HELPFUL_LINKS"] = "helpful links";
  SCREEN_NAMES2["FILTERS"] = "filters";
  SCREEN_NAMES2["RECENT_CLAIMS_WIDGET"] = "recent claims widget";
  SCREEN_NAMES2["ACTIVITY_STACK_WIDGET"] = "activity stack widget";
  SCREEN_NAMES2["PROGRAM_WITH_PROGRESS_CAROUSEL_WIDGET"] = "program with progress carousel widget";
  SCREEN_NAMES2["MAINTENANCE_PAGE"] = "maintenance page";
  SCREEN_NAMES2["EDIT_DISPLAY_NAME"] = "edit display name";
  SCREEN_NAMES2["TEXT_TC_MODAL"] = "text tc modal";
  SCREEN_NAMES2["TEXT_TERMS_AND_CONDITIONS"] = "text terms and conditions";
  SCREEN_NAMES2["DOCUMENT_PREFERENCES"] = "document preferences";
  return SCREEN_NAMES2;
})(SCREEN_NAMES || {});

// src/local-logger/debug-logger.ts
import { getConfig as getConfig2 } from "@leagueplatform/config";

// src/local-logger/local-log-store.ts
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
var localLogStore = create()(
  persist(
    (set, get) => ({
      // Initial state
      localLog: [],
      screenshots: [],
      // Actions
      clearAndResetLog: () => {
        localStorage.removeItem("local-user-event-log");
        set(() => ({
          localLog: [],
          screenshots: []
        }));
      },
      pushEvent: (event) => {
        const currentLog = get().localLog;
        set({ localLog: [...currentLog, event] });
      },
      pushScreenshot: (screenshot) => {
        const currentScreenshots = get().screenshots;
        set({ screenshots: [...currentScreenshots, screenshot] });
      }
    }),
    // Persist the state in localStorage so it lasts between refreshes
    {
      // key in localStorage for the persisted state
      name: "local-user-event-log",
      storage: createJSONStorage(() => localStorage),
      // Persist both localLog and screenshots (not the actions)
      partialize: (state) => ({
        localLog: state.localLog,
        screenshots: state.screenshots
      })
    }
  )
);

// src/local-logger/screenshot-utils.ts
import { toCanvas } from "html-to-image";

// src/local-logger/constants.ts
var ConsoleKey = "ANALYTICS";
var LocalStorageEnableKey = "show_analytics_events";

// src/local-logger/screenshot-utils.ts
var SCREENSHOT_CONFIG = {
  quality: 0.8,
  pixelRatio: 1
};
var generateScreenshotId = () => `screenshot_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
var captureViewportScreenshot = () => __async(void 0, null, function* () {
  try {
    const viewportSize = {
      width: window.innerWidth,
      height: window.innerHeight
    };
    const canvas = yield toCanvas(document.body, {
      pixelRatio: SCREENSHOT_CONFIG.pixelRatio,
      width: viewportSize.width,
      height: viewportSize.height,
      skipFonts: true,
      filter: (node) => {
        if (node.tagName === "IMG") {
          const img = node;
          if (img.crossOrigin === "anonymous" || img.src.startsWith(window.location.origin))
            return true;
          return false;
        }
        return true;
      }
    });
    const dataUrl = canvas.toDataURL("image/webp", SCREENSHOT_CONFIG.quality);
    return {
      id: generateScreenshotId(),
      dataUrl
    };
  } catch (error) {
    console.warn(
      `${ConsoleKey} Warning: Failed to capture screenshot:`,
      error
    );
    return null;
  }
});
function isScreenshotSupported() {
  return typeof window !== "undefined" && typeof document !== "undefined";
}
function openScreenshot(index) {
  return __async(this, null, function* () {
    const { screenshots } = localLogStore.getState();
    const screenshot = screenshots[index];
    if (!screenshot) {
      console.warn(
        `${ConsoleKey} Warning: Screenshot at index ${index} not found`
      );
      return;
    }
    try {
      const response = yield fetch(screenshot.dataUrl);
      const blob = yield response.blob();
      const blobUrl = URL.createObjectURL(blob);
      const newWindow = window.open(blobUrl, "_blank");
      if (newWindow) {
        setTimeout(() => URL.revokeObjectURL(blobUrl), 1e3);
      }
    } catch (error) {
      console.warn(
        `${ConsoleKey} Warning: Failed to open screenshot in new tab:`,
        error
      );
    }
  });
}

// src/local-logger/pdf-export/pdf-exporter.ts
import { PDFDocument, rgb, StandardFonts, PDFName, PDFString } from "pdf-lib";
var LAYOUT = {
  MARGIN: 20,
  LINE_HEIGHT: 14,
  MIN_REMAINING_SPACE: 20,
  PAYLOAD: {
    RECTANGLE_OFFSET: 25,
    TEXT_OFFSET: 30,
    RECTANGLE_EXTRA: 16,
    TEXT_PADDING: 8
  }
};
var FONT_SIZES = {
  HEADER: 16,
  BODY: 12,
  CODE: 10,
  ERROR: 10
};
var COLORS = {
  BACKGROUND: rgb(0.97, 0.97, 0.97),
  TEXT: rgb(0.24, 0.24, 0.24),
  SEPARATOR: rgb(0.8, 0.8, 0.8),
  BLACK: rgb(0, 0, 0),
  GRAY: rgb(0.5, 0.5, 0.5),
  LIGHT_GRAY: rgb(0.7, 0.7, 0.7),
  WHITE: rgb(1, 1, 1)
};
var IMAGE_CONFIG = {
  MAX_HEIGHT: 1e3,
  MAX_WIDTH: 2e3,
  COMPRESSION_QUALITY: 1,
  JPEG_SIZE_THRESHOLD: 0.7
  // Use JPEG if 30% smaller than PNG
};
var JSON_INDENT_SPACES = 1;
var createErrorMessage = (error) => error instanceof Error ? error.message : "Unknown error";
var dataUrlToBytes = (dataUrl) => {
  const base64Data = dataUrl.split(",")[1];
  if (!base64Data) {
    throw new Error("Invalid data URL format - no base64 data found");
  }
  try {
    return Uint8Array.from(atob(base64Data), (c) => c.charCodeAt(0));
  } catch (decodeError) {
    throw new Error(`Base64 decode failed: ${createErrorMessage(decodeError)}`);
  }
};
var calculateImageDimensions = (originalWidth, originalHeight, maxWidth, maxHeight) => {
  const widthRatio = maxWidth / originalWidth;
  const heightRatio = maxHeight / originalHeight;
  const scale = Math.min(widthRatio, heightRatio, 1);
  return {
    width: originalWidth * scale,
    height: originalHeight * scale
  };
};
var convertWebPToPng = (dataUrl) => __async(void 0, null, function* () {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  const img = new Image();
  const imageLoaded = new Promise((resolve, reject) => {
    img.onload = () => resolve();
    img.onerror = () => reject(new Error("Failed to load WebP image"));
    img.src = dataUrl;
  });
  yield imageLoaded;
  canvas.width = img.width;
  canvas.height = img.height;
  ctx == null ? void 0 : ctx.drawImage(img, 0, 0);
  const pngDataUrl = canvas.toDataURL("image/png");
  const pngBase64 = pngDataUrl.split(",")[1];
  return Uint8Array.from(atob(pngBase64), (c) => c.charCodeAt(0));
});
var compressImage = (dataUrl) => __async(void 0, null, function* () {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  const img = new Image();
  const imageLoaded = new Promise((resolve, reject) => {
    img.onload = () => resolve();
    img.onerror = () => reject(new Error("Failed to load image for compression"));
    img.src = dataUrl;
  });
  yield imageLoaded;
  const needsResizing = img.width > IMAGE_CONFIG.MAX_WIDTH * 1.5 || img.height > IMAGE_CONFIG.MAX_HEIGHT * 1.5;
  let targetWidth = img.width;
  let targetHeight = img.height;
  if (needsResizing) {
    const dimensions = calculateImageDimensions(
      img.width,
      img.height,
      IMAGE_CONFIG.MAX_WIDTH,
      IMAGE_CONFIG.MAX_HEIGHT
    );
    targetWidth = dimensions.width;
    targetHeight = dimensions.height;
  }
  canvas.width = targetWidth;
  canvas.height = targetHeight;
  if (ctx) {
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = "high";
    ctx.drawImage(img, 0, 0, targetWidth, targetHeight);
  }
  const pngDataUrl = canvas.toDataURL("image/png");
  const pngBase64 = pngDataUrl.split(",")[1];
  const pngBytes = Uint8Array.from(atob(pngBase64), (c) => c.charCodeAt(0));
  const jpegDataUrl = canvas.toDataURL(
    "image/jpeg",
    IMAGE_CONFIG.COMPRESSION_QUALITY
  );
  const jpegBase64 = jpegDataUrl.split(",")[1];
  const jpegBytes = Uint8Array.from(atob(jpegBase64), (c) => c.charCodeAt(0));
  if (jpegBytes.length < pngBytes.length * IMAGE_CONFIG.JPEG_SIZE_THRESHOLD) {
    return { dataUrl: jpegDataUrl, bytes: jpegBytes };
  }
  return { dataUrl: pngDataUrl, bytes: pngBytes };
});
var dataUrlToBlob = (dataUrl) => __async(void 0, null, function* () {
  try {
    const response = yield fetch(dataUrl);
    const blob = yield response.blob();
    const arrayBuffer = yield blob.arrayBuffer();
    return new Uint8Array(arrayBuffer);
  } catch (error) {
    throw new Error(
      `Failed to convert data URL to blob: ${createErrorMessage(error)}`
    );
  }
});
var isJpegDataUrl = (dataUrl) => dataUrl.startsWith("data:image/jpeg") || dataUrl.startsWith("data:image/jpg");
var isWebPDataUrl = (dataUrl) => dataUrl.startsWith("data:image/webp");
var tryEmbedImage = (pdfDoc, imageBytes, dataUrl) => __async(void 0, null, function* () {
  if (isWebPDataUrl(dataUrl)) {
    const pngBytes = yield convertWebPToPng(dataUrl);
    return pdfDoc.embedPng(pngBytes);
  }
  if (isJpegDataUrl(dataUrl)) {
    try {
      return yield pdfDoc.embedJpg(imageBytes);
    } catch (e) {
      return yield pdfDoc.embedPng(imageBytes);
    }
  }
  try {
    return yield pdfDoc.embedPng(imageBytes);
  } catch (e) {
    return yield pdfDoc.embedJpg(imageBytes);
  }
});
var embedImage = (pdfDoc, screenshot) => __async(void 0, null, function* () {
  try {
    const compressed = yield compressImage(screenshot.dataUrl);
    return yield tryEmbedImage(pdfDoc, compressed.bytes, compressed.dataUrl);
  } catch (compressionError) {
    try {
      const imageBytes = yield dataUrlToBlob(screenshot.dataUrl);
      return yield tryEmbedImage(pdfDoc, imageBytes, screenshot.dataUrl);
    } catch (blobError) {
      const imageBytes = dataUrlToBytes(screenshot.dataUrl);
      return yield tryEmbedImage(pdfDoc, imageBytes, screenshot.dataUrl);
    }
  }
});
var optimizeJsonPayload = (payload) => JSON.stringify(payload, null, JSON_INDENT_SPACES);
var createNewPage = (pdfDoc) => {
  const page = pdfDoc.addPage();
  const { width, height } = page.getSize();
  return { page, width, height, yPosition: height - 50 };
};
var hasEnoughSpace = (yPosition, requiredSpace) => yPosition - requiredSpace >= LAYOUT.MIN_REMAINING_SPACE;
var drawEventPayloadWithPagination = (currentPage, pdfDoc, event, width, yPosition, monoFont) => {
  let page = currentPage;
  let currentY = yPosition;
  const labelSpace = 20;
  if (!hasEnoughSpace(currentY, labelSpace)) {
    const pageInfo = createNewPage(pdfDoc);
    page = pageInfo.page;
    currentY = pageInfo.yPosition;
  }
  page.drawText("Event Payload:", {
    x: LAYOUT.MARGIN,
    y: currentY,
    size: FONT_SIZES.BODY,
    font: monoFont,
    color: COLORS.BLACK
  });
  currentY -= 15;
  const eventDetails = optimizeJsonPayload(event.props);
  const maxWidth = width - 60;
  const lines = eventDetails.split("\n");
  let lineIndex = 0;
  while (lineIndex < lines.length) {
    const availableSpace = currentY - LAYOUT.MIN_REMAINING_SPACE;
    const maxLinesOnPage = Math.floor(
      (availableSpace - LAYOUT.PAYLOAD.RECTANGLE_EXTRA) / LAYOUT.LINE_HEIGHT
    );
    if (maxLinesOnPage <= 0) {
      const pageInfo = createNewPage(pdfDoc);
      page = pageInfo.page;
      currentY = pageInfo.yPosition;
      continue;
    }
    const endIndex = Math.min(lineIndex + maxLinesOnPage, lines.length);
    const pageLines = lines.slice(lineIndex, endIndex);
    const backgroundHeight = pageLines.length * LAYOUT.LINE_HEIGHT + LAYOUT.PAYLOAD.RECTANGLE_EXTRA;
    page.drawRectangle({
      x: LAYOUT.PAYLOAD.RECTANGLE_OFFSET,
      y: currentY - backgroundHeight + LAYOUT.PAYLOAD.TEXT_PADDING,
      width: maxWidth,
      height: backgroundHeight,
      color: COLORS.BACKGROUND
    });
    let textY = currentY - LAYOUT.PAYLOAD.TEXT_PADDING;
    for (let lineIdx = 0; lineIdx < pageLines.length; lineIdx += 1) {
      const line = pageLines[lineIdx];
      page.drawText(line, {
        x: LAYOUT.PAYLOAD.TEXT_OFFSET,
        y: textY,
        size: FONT_SIZES.CODE,
        font: monoFont,
        color: COLORS.TEXT
      });
      textY -= LAYOUT.LINE_HEIGHT;
    }
    currentY -= backgroundHeight + 20;
    lineIndex = endIndex;
    if (lineIndex < lines.length) {
      const pageInfo = createNewPage(pdfDoc);
      page = pageInfo.page;
      currentY = pageInfo.yPosition;
    }
  }
  return { page, yPosition: currentY };
};
var renderScreenshotSectionWithPagination = (currentPage, pdfDoc, event, screenshots, width, yPosition, font) => __async(void 0, null, function* () {
  let page = currentPage;
  let currentY = yPosition;
  if (event.screenshotIndex === void 0) {
    return { page, yPosition: currentY };
  }
  const screenshot = screenshots[event.screenshotIndex];
  if (!(screenshot == null ? void 0 : screenshot.dataUrl)) {
    const errorSpace = 30;
    if (!hasEnoughSpace(currentY, errorSpace)) {
      const pageInfo = createNewPage(pdfDoc);
      page = pageInfo.page;
      currentY = pageInfo.yPosition;
    }
    page.drawText("No screenshot data available", {
      x: LAYOUT.MARGIN,
      y: currentY,
      size: FONT_SIZES.ERROR,
      font,
      color: COLORS.GRAY
    });
    return { page, yPosition: currentY - 20 };
  }
  try {
    const image = yield embedImage(pdfDoc, screenshot);
    const maxImageWidth = Math.min(
      width - LAYOUT.MARGIN * 2,
      IMAGE_CONFIG.MAX_WIDTH
    );
    const originalDims = image.size();
    const { width: imgWidth, height: imgHeight } = calculateImageDimensions(
      originalDims.width,
      originalDims.height,
      maxImageWidth,
      IMAGE_CONFIG.MAX_HEIGHT
    );
    const imageSpace = imgHeight + 30;
    if (!hasEnoughSpace(currentY, imageSpace)) {
      const pageInfo = createNewPage(pdfDoc);
      page = pageInfo.page;
      currentY = pageInfo.yPosition;
    }
    const imageY = currentY - imgHeight - 10;
    const centerX = (width - imgWidth) / 2;
    page.drawImage(image, {
      x: centerX,
      y: imageY,
      width: imgWidth,
      height: imgHeight
    });
    return { page, yPosition: imageY - 20 };
  } catch (error) {
    const errorSpace = 30;
    if (!hasEnoughSpace(currentY, errorSpace)) {
      const pageInfo = createNewPage(pdfDoc);
      page = pageInfo.page;
      currentY = pageInfo.yPosition;
    }
    const errorMessage = createErrorMessage(error);
    page.drawText(`Screenshot failed to load: ${errorMessage}`, {
      x: LAYOUT.MARGIN,
      y: currentY,
      size: FONT_SIZES.ERROR,
      font,
      color: COLORS.GRAY
    });
    return { page, yPosition: currentY - 30 };
  }
});
var createExpectedPayloadField = (page, form, width, yPosition, eventIndex, monoFont) => {
  page.drawText("Expected Payload:", {
    x: LAYOUT.MARGIN,
    y: yPosition,
    size: FONT_SIZES.BODY,
    font: monoFont,
    color: COLORS.BLACK
  });
  const labelY = yPosition - 15;
  const remainingHeight = labelY - LAYOUT.MARGIN;
  const textField = form.createTextField(
    `expected_payload_event_${eventIndex + 1}`
  );
  textField.setText("");
  textField.enableMultiline();
  textField.addToPage(page, {
    x: LAYOUT.MARGIN,
    y: LAYOUT.MARGIN,
    width: width - LAYOUT.MARGIN * 2,
    height: remainingHeight,
    borderWidth: 1,
    borderColor: COLORS.LIGHT_GRAY,
    backgroundColor: COLORS.WHITE
  });
  const fieldDict = textField.acroField.dict;
  fieldDict.set(
    PDFName.of("DA"),
    PDFString.of(`/Cour ${FONT_SIZES.BODY} Tf 0 0 0 rg`)
  );
};
var downloadPdf = (pdfBytes, filename) => {
  const blob = new Blob([pdfBytes], { type: "application/pdf" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${filename}.pdf`;
  link.click();
  URL.revokeObjectURL(url);
};
var exportToPdf = (_0) => __async(void 0, [_0], function* ({
  events: events2,
  screenshots,
  filename = "analytics-debug-log"
}) {
  const pdfDoc = yield PDFDocument.create();
  const [font, boldFont, monoFont] = yield Promise.all([
    pdfDoc.embedFont(StandardFonts.Helvetica),
    pdfDoc.embedFont(StandardFonts.HelveticaBold),
    pdfDoc.embedFont(StandardFonts.Courier)
  ]);
  const form = pdfDoc.getForm();
  let currentPage = null;
  let width = 0;
  let yPosition = 0;
  for (let i = 0; i < events2.length; i += 1) {
    const event = events2[i];
    const headerSpace = 50;
    if (!currentPage || !hasEnoughSpace(yPosition, headerSpace)) {
      const pageInfo = createNewPage(pdfDoc);
      currentPage = pageInfo.page;
      width = pageInfo.width;
      yPosition = pageInfo.yPosition;
    }
    currentPage.drawText(`Event ${i + 1}: ${event.eventName}`, {
      x: LAYOUT.MARGIN,
      y: yPosition,
      size: FONT_SIZES.HEADER,
      font: boldFont,
      color: COLORS.BLACK
    });
    yPosition -= 20;
    currentPage.drawLine({
      start: { x: LAYOUT.MARGIN, y: yPosition },
      end: { x: width - LAYOUT.MARGIN, y: yPosition },
      thickness: 1,
      color: COLORS.SEPARATOR
    });
    yPosition -= 25;
    const payloadResult = drawEventPayloadWithPagination(
      currentPage,
      pdfDoc,
      event,
      width,
      yPosition,
      monoFont
    );
    currentPage = payloadResult.page;
    yPosition = payloadResult.yPosition;
    const screenshotResult = yield renderScreenshotSectionWithPagination(
      currentPage,
      pdfDoc,
      event,
      screenshots,
      width,
      yPosition,
      font
    );
    currentPage = screenshotResult.page;
    yPosition = screenshotResult.yPosition;
    const expectedPayloadSpace = 150;
    if (!hasEnoughSpace(yPosition, expectedPayloadSpace)) {
      const pageInfo = createNewPage(pdfDoc);
      currentPage = pageInfo.page;
      width = pageInfo.width;
      yPosition = pageInfo.yPosition;
    }
    createExpectedPayloadField(
      currentPage,
      form,
      width,
      yPosition,
      i,
      monoFont
    );
    yPosition = LAYOUT.MIN_REMAINING_SPACE;
  }
  const pdfBytes = yield pdfDoc.save({
    useObjectStreams: true,
    addDefaultPage: false,
    objectsPerTick: 50
  });
  downloadPdf(pdfBytes, filename);
});

// src/local-logger/debug-logger.ts
var LogEventLimit = 50;
var LogLengthNotifierUnit = 10;
var cachedConfig = null;
var getMemoizedConfig = () => {
  if (!cachedConfig) {
    cachedConfig = getConfig2(false);
  }
  return cachedConfig;
};
var getIsDebugLoggingEnabled = () => {
  var _a, _b, _c, _d;
  const { config } = getMemoizedConfig();
  return Boolean((_a = config == null ? void 0 : config.core) == null ? void 0 : _a.appEnvironment) && ((_b = config == null ? void 0 : config.core) == null ? void 0 : _b.appEnvironment) !== "production" && Boolean((_d = (_c = config == null ? void 0 : config.core) == null ? void 0 : _c.analytics) == null ? void 0 : _d.shouldEnableLocalAnalyticsLogging) && localStorage.getItem(LocalStorageEnableKey) === "true";
};
var resetUserEventsLog = () => {
  localLogStore.getState().clearAndResetLog();
  return `${ConsoleKey} Info: User events log has been reset. New events can now be added.`;
};
var exportUserEventsLog = (name = "analytics-debug-log") => __async(void 0, null, function* () {
  if (getIsDebugLoggingEnabled()) {
    const { localLog, screenshots } = localLogStore.getState();
    try {
      yield exportToPdf({ events: localLog, screenshots, filename: name });
      console.log(
        `${ConsoleKey} Info: PDF exported successfully as "${name}.pdf"`
      );
      const resetMessage = resetUserEventsLog();
      console.log(resetMessage);
      return resetMessage;
    } catch (error) {
      console.error(
        `${ConsoleKey} Error: Failed to export PDF. You can either:

        - Try again by typing \`exportUserEventsLog('your-log-name-here')\` in the console and hitting \`enter\`.

        - Clear the log without exporting by typing \`resetUserEventsLog()\` in the console and hitting \`enter\` to continue logging new events.`
      );
      return error instanceof Error;
    }
  } else {
    return `${ConsoleKey} Warning: Export is disabled in production environments.`;
  }
});
window.exportUserEventsLog = exportUserEventsLog;
window.resetUserEventsLog = resetUserEventsLog;
window.openScreenshot = openScreenshot;
var handleDebugLogging = (event) => __async(void 0, null, function* () {
  if (getIsDebugLoggingEnabled()) {
    const { localLog } = localLogStore.getState();
    if (localLog.length === LogEventLimit) {
      console.log(
        `${ConsoleKey} Warning: Local log is full and new events cannot be added.
Type \`exportUserEventsLog('your-log-name-here')\` in the console and hit \`enter\` to export the data and free up space for new events.
Type \`resetUserEventsLog()\` and hit \`enter\` in the console to reset the log without exporting.`
      );
    } else {
      const currentPath = window.location.pathname + window.location.search;
      const metadata = {
        eventUrl: currentPath
      };
      let eventToStore = __spreadProps(__spreadValues({}, event), {
        props: __spreadProps(__spreadValues({}, event.props), {
          metadata
        })
      });
      if (isScreenshotSupported()) {
        try {
          const screenshotData = yield captureViewportScreenshot();
          if (screenshotData) {
            const { screenshots } = localLogStore.getState();
            localLogStore.getState().pushScreenshot(screenshotData);
            eventToStore = __spreadProps(__spreadValues({}, eventToStore), {
              screenshotIndex: screenshots.length
            });
          }
        } catch (error) {
          console.warn(
            `${ConsoleKey} Warning: Screenshot capture failed:`,
            error
          );
        }
      }
      localLogStore.getState().pushEvent(eventToStore);
      const newLength = localLog.length + 1;
      console.log(`${ConsoleKey} Logging:`, eventToStore);
      if (newLength % LogLengthNotifierUnit === 0 && newLength !== LogEventLimit) {
        console.log(`${ConsoleKey} Info: Log length is now ${newLength}.`);
      }
      if (newLength === LogEventLimit - 1) {
        console.log(
          `${ConsoleKey} Warning: only 1 more event can be added before data must be exported.`
        );
      }
      if (newLength === LogEventLimit) {
        console.log(
          `${ConsoleKey} Warning: Local log is now full. Type \`exportUserEventsLog('your-log-name-here')\` in the console to export the data.`
        );
      }
    }
  }
});

// src/analytics.ts
var identify = (user) => {
  var _a, _b;
  if (!user)
    return;
  segmentIdentify(user);
  try {
    (_b = (_a = getConfig3().config.core.analytics) == null ? void 0 : _a.onIdentify) == null ? void 0 : _b.call(_a, user);
  } catch (error) {
    console.error("There was an error in the onIdentify method:", error);
  }
};
var trackAnalyticsEvent = (_0, ..._1) => __async(void 0, [_0, ..._1], function* (eventName, props = {}) {
  var _a, _b;
  if (typeof eventName !== "string")
    throw new Error("Analytics - eventName argument must be of type string");
  const isImpersonator = yield getIsImpersonator();
  const analyticsProps = __spreadValues(__spreadValues({}, props), isImpersonator ? { impersonation_type: "AGENT" } : {});
  sendSegmentEvent(eventName, analyticsProps);
  yield handleDebugLogging({ eventName, props: analyticsProps });
  const legacyParams = __spreadValues({
    category: analyticsProps.screen_name,
    action: analyticsProps.detail,
    label: analyticsProps.sub_detail || analyticsProps.sub_product_area
  }, analyticsProps);
  sendAnalyticsToLeague(legacyParams, GA_EVENT);
  try {
    (_b = (_a = getConfig3().config.core.analytics) == null ? void 0 : _a.onTrackEvent) == null ? void 0 : _b.call(_a, eventName, props);
  } catch (error) {
    console.error("There was an error in the onTrackEvent method:", error);
  }
});
var sendAnalyticsEvent = (params, name = GA_EVENT) => {
  sendAnalyticsToLeague(params, name);
  sendSegmentEvent("button clicked" /* BUTTON_CLICKED */, params);
};
var sendAnalyticsPageView = (params, name = GA_EVENT) => {
  var _a, _b;
  const props = __spreadValues({
    screen_name: params.title,
    path: params.path || window.location.pathname
  }, params);
  sendAnalyticsToLeague(props, name);
  sendSegmentEvent("screen loaded" /* SCREEN_LOADED */, props);
  try {
    (_b = (_a = getConfig3().config.core.analytics) == null ? void 0 : _a.onTrackEvent) == null ? void 0 : _b.call(
      _a,
      "screen loaded" /* SCREEN_LOADED */,
      props
    );
  } catch (error) {
    console.error("There was an error in the onTrackEvent method:", error);
  }
};

// src/analytics-events/wallet.ts
var wallet = {
  "events": {
    "button_clicked_apply_discount": {
      "event_name": "button clicked",
      "metadata": {
        "domain": "wallet",
        "placeholders": {}
      },
      "optional": {
        "detail": "apply discount code",
        "sub_product_area": "electronics"
      },
      "product_area": "care",
      "screen_name": "checkout"
    },
    "button_clicked_choose_plan": {
      "event_name": "button clicked",
      "metadata": {
        "domain": "wallet",
        "placeholders": {}
      },
      "optional": {
        "detail": "choose insurance plan",
        "sub_product_area": "term"
      },
      "product_area": "health journey",
      "screen_name": "selection page"
    },
    "button_clicked_collapse_policy": {
      "event_name": "button clicked",
      "metadata": {
        "domain": "wallet",
        "placeholders": {}
      },
      "optional": {
        "detail": "- hide policy",
        "sub_product_area": "vision"
      },
      "product_area": "health journey",
      "screen_name": "policy details"
    },
    "button_clicked_coverage_info": {
      "event_name": "button clicked",
      "metadata": {
        "domain": "wallet",
        "placeholders": {
          "optional.detail": [
            "max_coverage"
          ]
        }
      },
      "optional": {
        "detail": "Your dental coverage limit is %{max_coverage}.",
        "sub_product_area": "dental"
      },
      "product_area": "health journey",
      "screen_name": "coverage page"
    },
    "button_clicked_download_invoice": {
      "event_name": "button clicked",
      "metadata": {
        "domain": "wallet",
        "placeholders": {}
      },
      "optional": {
        "detail": "download invoice PDF",
        "sub_product_area": "invoices"
      },
      "product_area": "claims",
      "screen_name": "billing history"
    },
    "button_clicked_enable_notifications": {
      "event_name": "button clicked",
      "metadata": {
        "domain": "wallet",
        "placeholders": {}
      },
      "optional": {
        "detail": "enable push notifications",
        "sub_product_area": "notifications"
      },
      "product_area": "settings",
      "screen_name": "settings page"
    },
    "button_clicked_expand_billing": {
      "event_name": "button clicked",
      "metadata": {
        "domain": "wallet",
        "placeholders": {}
      },
      "optional": {
        "detail": "+ show transactions",
        "sub_product_area": "bills"
      },
      "product_area": "claims",
      "screen_name": "billing page"
    },
    "button_clicked_expand_wallet": {
      "event_name": "button clicked",
      "metadata": {
        "domain": "wallet",
        "placeholders": {}
      },
      "optional": {
        "detail": "+ expand details",
        "sub_product_area": "savings"
      },
      "product_area": "wallet",
      "screen_name": "summary page"
    },
    "button_clicked_filter_transactions": {
      "event_name": "button clicked",
      "metadata": {
        "domain": "wallet",
        "placeholders": {}
      },
      "optional": {
        "detail": "apply transaction filters",
        "sub_product_area": "analytics"
      },
      "product_area": "settings",
      "screen_name": "transactions page"
    },
    "button_clicked_open_support_chat": {
      "event_name": "button clicked",
      "metadata": {
        "domain": "wallet",
        "placeholders": {}
      },
      "optional": {
        "detail": "start chat with agent",
        "sub_product_area": "live chat"
      },
      "product_area": "care",
      "screen_name": "help center"
    },
    "button_clicked_redeem_points": {
      "event_name": "button clicked",
      "metadata": {
        "domain": "wallet",
        "placeholders": {}
      },
      "optional": {
        "detail": "redeem points for reward",
        "sub_product_area": "redemption"
      },
      "product_area": "rewards",
      "screen_name": "rewards catalog"
    },
    "button_clicked_request_refund": {
      "event_name": "button clicked",
      "metadata": {
        "domain": "wallet",
        "placeholders": {}
      },
      "optional": {
        "detail": "request refund",
        "sub_product_area": "returns"
      },
      "product_area": "wallet",
      "screen_name": "order history"
    },
    "button_clicked_reset_password": {
      "event_name": "button clicked",
      "metadata": {
        "domain": "wallet",
        "placeholders": {}
      },
      "optional": {
        "detail": "reset password request",
        "sub_product_area": "security"
      },
      "product_area": "settings",
      "screen_name": "login page"
    },
    "button_clicked_save_payment_method": {
      "event_name": "button clicked",
      "metadata": {
        "domain": "wallet",
        "placeholders": {}
      },
      "optional": {
        "detail": "save new card",
        "sub_product_area": "cards"
      },
      "product_area": "claims",
      "screen_name": "payment options"
    },
    "button_clicked_share_post": {
      "event_name": "button clicked",
      "metadata": {
        "domain": "wallet",
        "placeholders": {}
      },
      "optional": {
        "detail": "share post",
        "sub_product_area": "sharing"
      },
      "product_area": "health journey",
      "screen_name": "news feed"
    },
    "button_clicked_toggle_dark_mode": {
      "event_name": "button clicked",
      "metadata": {
        "domain": "wallet",
        "placeholders": {}
      },
      "optional": {
        "detail": "toggle dark mode",
        "sub_product_area": "appearance"
      },
      "product_area": "settings",
      "screen_name": "display settings"
    },
    "button_clicked_track_shipment": {
      "event_name": "button clicked",
      "metadata": {
        "domain": "wallet",
        "placeholders": {}
      },
      "optional": {
        "detail": "track order status",
        "sub_product_area": "express"
      },
      "product_area": "claims",
      "screen_name": "tracking page"
    },
    "button_clicked_upgrade_plan": {
      "event_name": "button clicked",
      "metadata": {
        "domain": "wallet",
        "placeholders": {}
      },
      "optional": {
        "detail": "upgrade to premium",
        "sub_product_area": "premium"
      },
      "product_area": "get care",
      "screen_name": "subscription page"
    },
    "button_clicked_view_card_details": {
      "event_name": "button clicked",
      "metadata": {
        "domain": "wallet",
        "placeholders": {}
      },
      "optional": {
        "detail": "view front of card",
        "sub_product_area": "premium"
      },
      "product_area": "wallet",
      "screen_name": "card page"
    },
    "screen_loaded_account_summary": {
      "event_name": "screen loaded",
      "metadata": {
        "domain": "wallet",
        "placeholders": {}
      },
      "optional": {
        "detail": "account overview",
        "sub_product_area": "personal accounts"
      },
      "product_area": "wallet",
      "screen_name": "dashboard"
    },
    "screen_loaded_medication_page": {
      "event_name": "screen loaded",
      "metadata": {
        "domain": "wallet",
        "placeholders": {}
      },
      "optional": {
        "detail": "view prescription details",
        "sub_product_area": "online orders"
      },
      "product_area": "home screen",
      "screen_name": "medication details"
    },
    "screen_loaded_order_confirmation": {
      "event_name": "screen loaded",
      "metadata": {
        "domain": "wallet",
        "placeholders": {}
      },
      "optional": {
        "detail": "view order confirmation",
        "sub_product_area": "confirmation"
      },
      "product_area": "wallet",
      "screen_name": "order success"
    },
    "screen_loaded_personal_profile": {
      "event_name": "screen loaded",
      "metadata": {
        "domain": "wallet",
        "placeholders": {}
      },
      "optional": {
        "detail": "view user profile",
        "sub_product_area": "user data"
      },
      "product_area": "settings",
      "screen_name": "profile page"
    },
    "screen_loaded_policy_details": {
      "event_name": "screen loaded",
      "metadata": {
        "domain": "wallet",
        "placeholders": {}
      },
      "optional": {
        "detail": "view dental policy",
        "sub_product_area": "dental"
      },
      "product_area": "health journey",
      "screen_name": "policy overview"
    },
    "screen_loaded_rewards_dashboard": {
      "event_name": "screen loaded",
      "metadata": {
        "domain": "wallet",
        "placeholders": {}
      },
      "optional": {
        "detail": "view reward points balance",
        "sub_product_area": "points"
      },
      "product_area": "rewards",
      "screen_name": "dashboard"
    },
    "screen_loaded_security_settings": {
      "event_name": "screen loaded",
      "metadata": {
        "domain": "wallet",
        "placeholders": {}
      },
      "optional": {
        "detail": "update privacy settings",
        "sub_product_area": "privacy"
      },
      "product_area": "settings",
      "screen_name": "security page"
    },
    "screen_loaded_transaction_history": {
      "event_name": "screen loaded",
      "metadata": {
        "domain": "wallet",
        "placeholders": {}
      },
      "optional": {
        "detail": "view transaction records",
        "sub_product_area": "transactions"
      },
      "product_area": "wallet",
      "screen_name": "history page"
    }
  }
};

// src/analytics-events.ts
var events = __spreadValues({}, wallet.events);
function track(eventKey, ...args) {
  const eventId = eventKey.split(".")[1];
  const _a = events[eventId], { metadata, optional } = _a, event = __objRest(_a, ["metadata", "optional"]);
  const mergedEvent = __spreadValues(__spreadValues({}, optional != null ? optional : {}), event);
  const placeholders = args[0];
  if (!placeholders) {
    trackAnalyticsEvent(eventId, mergedEvent);
    return;
  }
  let stringifiedEvent = JSON.stringify(mergedEvent);
  Object.entries(
    placeholders
  ).forEach(([property, value]) => {
    if (typeof value === "string")
      stringifiedEvent = stringifiedEvent.replace(
        // eslint-disable-next-line no-useless-escape
        new RegExp(`%{${property}}`, "g"),
        value
      );
  });
  trackAnalyticsEvent(eventId, JSON.parse(stringifiedEvent));
}

// src/use-analytics.hooks.ts
import { useEffect } from "react";
var usePageViewAnalytics = (params, dependencies = [], name = GA_EVENT) => {
  if (!Array.isArray(dependencies))
    throw new Error("Provided hook dependencies must be an array");
  useEffect(() => {
    sendAnalyticsPageView(params, name);
  }, dependencies);
};

// src/index.ts
var isSegmentInitialized = false;
subscribeToConfig(
  (configWithStatus) => {
    var _a;
    if (!isConfigSettled(configWithStatus))
      return void 0;
    const { config } = configWithStatus;
    return {
      segmentKey: config["config_analytics_segment-key"],
      tenantId: config["config_core_tenant-id"],
      clientAnalytics: config.core.analytics,
      shouldNotAutoIdentifySegment: (
        // eslint-disable-next-line no-underscore-dangle
        !!((_a = config.__internal) == null ? void 0 : _a.shouldNotAutoIdentifySegment)
      )
    };
  },
  (selection) => {
    var _a;
    const segmentKey = ((_a = selection == null ? void 0 : selection.clientAnalytics) == null ? void 0 : _a.segmentKey) || (selection == null ? void 0 : selection.segmentKey);
    if (segmentKey) {
      if (isSegmentInitialized) {
        console.warn(
          "the config_analytics_segment-key config value has changed, but it is not possible to load Segment more than once. This will be ignored."
        );
        return;
      }
      segment.load(
        {
          writeKey: segmentKey
        },
        { obfuscate: true }
      );
      if (!selection.shouldNotAutoIdentifySegment && selection.tenantId) {
        const unlisten = Auth.addOnAuthListener(() => __async(void 0, null, function* () {
          const userId = yield Auth.getUserId();
          if (userId && selection.tenantId) {
            identify({
              id: userId,
              tenant_id: selection.tenantId,
              employer_group_id: ""
            });
          }
          unlisten();
        }));
      }
      isSegmentInitialized = true;
    }
  }
);
export {
  EVENT_NAME,
  GA_EVENT,
  PRODUCT_AREA,
  SCREEN_NAMES,
  SUB_PRODUCT_AREA,
  identify,
  isDesktop,
  reset,
  resetUserEventsLog,
  sendAnalyticsEvent,
  sendAnalyticsPageView,
  track,
  trackAnalyticsEvent,
  usePageViewAnalytics
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/analytics'] = window.leagueSDKsPresent['@leagueplatform/analytics'] || [];
    window.leagueSDKsPresent['@leagueplatform/analytics'].push('2.28.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/analytics'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/analytics module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map